import {FC} from 'react'
import {CsvRow, InputStepErr, InputStepInputCopyPasteType, InputStepMode, UploadPayload} from '..'
import InputStepUploadFile from './InputStepUploadFile'
import InputStepNumberOrCustom from './InputStepNumberOrCustom'
import UploadContactFooter from '../Element/UploadContactFooter'
import AddSingleContact from './AddSingleContact'

// ------ First step responsibility
// - handle user upload data
// - handle user add contact by number or custom
// - handle user checklist for confirmation

export type InputStepProps = {
  copyPasteType: InputStepInputCopyPasteType
  customData: string
  cswData: CsvRow[]
  error: InputStepErr
  finalData: UploadPayload
  inputMode: InputStepMode
  isLoading: boolean
  numberData: string
  isUnsubscribe?: boolean
  handleClose: () => void
  handleNext: () => void
  setCopyPasteType: (type: InputStepInputCopyPasteType) => void
  setCustomData: (data: string) => void
  setCsvData: (data: CsvRow[]) => void
  setError: (err: InputStepErr) => void
  setFinalData: (fd: UploadPayload) => void
  setInputMode: (mode: InputStepMode) => void
  setNumberData: (data: string) => void
}

const InputStep: FC<InputStepProps> = (props) => {
  const {
    inputMode,
    isLoading,
    cswData,
    error,
    copyPasteType,
    finalData,
    customData,
    numberData,
    isUnsubscribe = false,
    handleClose,
    handleNext,
    setCopyPasteType,
    setCustomData,
    setCsvData,
    setFinalData,
    setInputMode,
    setError,
    setNumberData,
  } = props

  const isAllowNext = () => {
    if (inputMode === InputStepMode.Upload && cswData.length === 0) {
      return false
    }

    if (
      inputMode === InputStepMode.CopyPaste &&
      numberData.length === 0 &&
      customData.length === 0
    ) {
      return false
    }

    return !isLoading
  }

  return (
    <div className='modal-body p-15'>
      <InputStepUploadFile
        error={error}
        finalData={finalData}
        inputMode={inputMode}
        setCsvData={setCsvData}
        setError={setError}
        setFinalData={setFinalData}
        setInputMode={(mode: InputStepMode) => {
          setInputMode(mode)
          setCustomData('')
          setNumberData('')
        }}
      />
      <InputStepNumberOrCustom
        copyPasteType={copyPasteType}
        customData={customData}
        error={error}
        inputMode={inputMode}
        numberData={numberData}
        setCopyPasteType={setCopyPasteType}
        setCustomData={setCustomData}
        setError={setError}
        setInputMode={(mode: InputStepMode) => {
          setInputMode(mode)
          setCsvData([])
          setCopyPasteType(InputStepInputCopyPasteType.Number)
          setFinalData({
            name: '',
            mergeLabels: '',
            tagIds: '',
            unSubList: false,
          })
        }}
        setNumberData={setNumberData}
      />
      {!isUnsubscribe && <AddSingleContact inputMode={inputMode} setInputMode={setInputMode} />}

      <UploadContactFooter
        isLoading={isLoading}
        allowedNext={isAllowNext()}
        handleClose={handleClose}
        handleNext={handleNext}
      />
    </div>
  )
}

export default InputStep
